import React from "react";
import { ArrowUpRight, Phone } from "lucide-react";
import { RESTAURANT, IMAGES } from "../data/menu";

const PARTNERS = [
  {
    name: "Uber Eats",
    color: "#06C167",
    url: "https://www.ubereats.com/gb/store/aradela-nigerian-restaurant/jd55Xw2yWyq3OzSMwnM1QQ?diningMode=DELIVERY&ps=1&sc=SEARCH_SUGGESTION",
    desc: "Fast delivery, live order tracking, frequent promos.",
    label: "Uber Eats",
  },
  {
    name: "Just Eat",
    color: "#FF8000",
    url: "https://www.just-eat.co.uk/restaurants-aradela-restaurant-milton-keynes/menu?utm_source=google&utm_medium=cpc&utm_campaign=CM_S_G_GBR_EN_%5BRES%5D_%5BENGM%5D_FDSA_National&utm_campaignid=14654756066&gad_source=1&gad_campaignid=14654756066&gclid=Cj0KCQjw2_TQBhCnARIsAF3-XhzjB2LD9y0a5syNTpQvs2ZJzPZnp5rS8Su0nbZoQSLyqEW-lZC4XjoaAhVKEALw_wcB#pre-order",
    desc: "Pre-order or order now — wide payment options.",
    label: "Just Eat",
  },
  {
    name: "Deliveroo",
    color: "#00CCBC",
    url: "https://deliveroo.co.uk/menu/Milton%20Keynes/old-wolverton/aradela-restaurant-19-stratford-road?srsltid=AfmBOopIYU2KnHQeMpz62q8YqDjlqPAx-8jVmy_Soa12SM1J1g-C7Ohu",
    desc: "Premium delivery with Plus member benefits.",
    label: "Deliveroo",
  },
];

export default function Order() {
  return (
    <main className="bg-[#0A0A0A] pt-[180px] pb-24" data-testid="order-page">
      <section className="relative py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.plating} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center">
          <span className="text-[#D4A017] uppercase tracking-[0.3em] text-xs">Order Online</span>
          <h1 className="font-impact uppercase text-white text-5xl md:text-7xl mt-3 tracking-tight">
            Aradelá, <span className="text-[#D4A017]">delivered</span>.
          </h1>
          <p className="text-white/65 mt-5 max-w-2xl mx-auto">
            Pick your favourite delivery partner — or simply give us a call to place your order.
          </p>
        </div>
      </section>

      {/* Partners */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-6" data-testid="order-partners">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {PARTNERS.map((p) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`order-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="group bg-[#141414] border border-white/5 p-7 hover:-translate-y-1 hover:border-white/20 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-start justify-between mb-6">
                <div
                  className="font-impact uppercase text-2xl tracking-wider"
                  style={{ color: p.color }}
                >
                  {p.label}
                </div>
                <span
                  className="w-10 h-10 rounded-full border flex items-center justify-center transition-colors"
                  style={{ borderColor: `${p.color}33`, color: p.color }}
                >
                  <ArrowUpRight size={16} />
                </span>
              </div>
              <h3 className="font-impact uppercase text-white text-2xl tracking-wider mb-2">
                Order on {p.name}
              </h3>
              <p className="text-white/55 text-sm mb-6">{p.desc}</p>
              <div
                className="mt-auto inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider"
                style={{ color: p.color }}
              >
                Order Now <ArrowUpRight size={14} />
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Call to Order */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-10" data-testid="order-call">
        <div className="bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-[#D4A017]/20 p-8 md:p-10 grid md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-8">
            <span className="text-[#D4A017] uppercase tracking-[0.3em] text-xs">Direct</span>
            <h3 className="font-impact uppercase text-white text-3xl md:text-4xl mt-3 tracking-wider">
              Order Direct — Call Us
            </h3>
            <p className="text-white/65 mt-3 max-w-xl">
              Skip the delivery apps and call us directly. Our team will guide you through the menu,
              confirm prep times, and arrange collection or delivery — no middleman fees.
            </p>
          </div>
          <div className="md:col-span-4 flex flex-col gap-3">
            <a
              href={`tel:${RESTAURANT.phoneRaw}`}
              className="inline-flex items-center justify-center gap-3 bg-[#D4A017] hover:bg-[#F0BE3F] text-black font-bold uppercase tracking-[0.12em] px-6 py-4 text-sm rounded-full transition-colors"
              data-testid="order-call-cta"
            >
              <Phone size={16} /> {RESTAURANT.phone}
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
